"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventsFromDayOneApiResponse = exports.createEvent = exports.eventComparer = exports.mergeDayOneAndTrainingEvents = exports.isEventInfoSame = exports.DATE_FORMAT = exports.TRAINING_TYPE_PHYSICAL = exports.EventType = void 0;
const luxon_1 = require("luxon");
const utils_1 = require("../utils");
var EventType;
(function (EventType) {
    EventType["DayOneShift"] = "dayOneEvent";
    EventType["Training"] = "trainingEvent";
    EventType["DayOneAndTrainingInfoSame"] = "dayOneAndTrainingInfoSame";
})(EventType = exports.EventType || (exports.EventType = {}));
exports.TRAINING_TYPE_PHYSICAL = 'Physical';
exports.DATE_FORMAT = 'yyyy-MM-dd';
/*
    1. startDateTime, endDateTime, location is same for both events
 */
const isEventInfoSame = (a, b) => +a.details.startDateTime === +b.details.startDateTime
    && a.details.location === b.details.location
    && (
    // If events have missing `endDateTime` then
    // we will consider them different because we
    // don't know when either one will end
    !!a.details.endDateTime
        && !!b.details.endDateTime
        && +a.details.endDateTime === +b.details.endDateTime);
exports.isEventInfoSame = isEventInfoSame;
// Merge DayOne and Training events if there eventInfo is same
const mergeDayOneAndTrainingEvents = (sortedEventsList, indexOfDayOneEvent) => {
    const eventList = sortedEventsList;
    if (indexOfDayOneEvent + 1 < eventList.length
        && eventList[indexOfDayOneEvent + 1].type === EventType.Training
        && (0, exports.isEventInfoSame)(eventList[indexOfDayOneEvent], eventList[indexOfDayOneEvent + 1])) {
        eventList[indexOfDayOneEvent].type = EventType.DayOneAndTrainingInfoSame;
        eventList.splice(indexOfDayOneEvent + 1, 1);
    }
    return eventList;
};
exports.mergeDayOneAndTrainingEvents = mergeDayOneAndTrainingEvents;
const eventComparer = (a, b) => {
    const aStartDateTime = a.details.startDateTime;
    const bStartDateTime = b.details.startDateTime;
    const aEndDateTime = a.details.endDateTime;
    const bEndDateTime = b.details.endDateTime;
    if (aStartDateTime < bStartDateTime) {
        return -1;
    }
    if (aStartDateTime > bStartDateTime) {
        return 1;
    }
    // startDateTimes are equal, then compare based on endDateTime
    if (aEndDateTime && bEndDateTime) {
        if (aEndDateTime < bEndDateTime) {
            return -1;
        }
        if (aEndDateTime > bEndDateTime) {
            return 1;
        }
        // endDateTimes are equal, then compare based on event types
        if (a.type === b.type) {
            return 0;
        }
    }
    // else we consider misssing end times to never be equal
    // because we don't know when either one will end
    /*
       Put DayOne first, any other event types will be in unspecified order
    */
    return a.type === EventType.DayOneShift ? -1 : 1;
};
exports.eventComparer = eventComparer;
const createEvent = (startTimeString, endTimeString, zone, address, currentDateTime, eventType) => {
    if (!startTimeString) {
        throw new Error('UseCandidateInfo: Unexpectedly start time is null or empty!');
    }
    const startDateTime = luxon_1.DateTime.fromISO(startTimeString).setZone(zone);
    let endDateTime = null;
    let complete;
    if (endTimeString) {
        endDateTime = luxon_1.DateTime.fromISO(endTimeString).setZone(zone);
        complete = currentDateTime > endDateTime;
    }
    else {
        // We don't know when it will actually complete...
        complete = false;
    }
    const diff = (0, utils_1.getDaysDiff)(startDateTime, currentDateTime);
    return {
        type: eventType,
        details: {
            startDateTime,
            endDateTime,
            location: address,
            completionInfo: {
                diff,
                complete,
            },
        },
    };
};
exports.createEvent = createEvent;
const getEventsFromDayOneApiResponse = (eventInfo, telemetry, isSpoofing) => {
    if (!eventInfo)
        return [];
    const firstDayInfo = eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.firstDayInfo;
    const currentDateTime = luxon_1.DateTime.utc().setZone(firstDayInfo.timeZone);
    const dayOneInfo = (0, exports.createEvent)(firstDayInfo.startDateTime, firstDayInfo.endDateTime, firstDayInfo.timeZone, firstDayInfo.buildingAddress, currentDateTime, EventType.DayOneShift);
    if (!isSpoofing && (currentDateTime.startOf('day') > dayOneInfo.details.startDateTime.endOf('day'))) {
        telemetry === null || telemetry === void 0 ? void 0 : telemetry.meter.createErrorCounter('PastDayOne').submit('Current date is past day one date.', {
            currentDateTime: currentDateTime.toISO(),
            dayOneStartDateTime: dayOneInfo.details.startDateTime.toISO(),
        });
    }
    const newHireOrientationList = eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.newHireOrientation.filter(({ type }) => type === exports.TRAINING_TYPE_PHYSICAL);
    if (!newHireOrientationList.length) {
        return [dayOneInfo];
    }
    const parsedTrainingInfoList = newHireOrientationList
        .map((trainingInfoNho) => (0, exports.createEvent)(trainingInfoNho.startDateTime, trainingInfoNho.endDateTime, trainingInfoNho.timeZone, trainingInfoNho.address, currentDateTime, EventType.Training));
    const sortedEventsList = parsedTrainingInfoList.concat(dayOneInfo)
        .sort(exports.eventComparer);
    const indexOfDayOneInfo = sortedEventsList.indexOf(dayOneInfo);
    return (0, exports.mergeDayOneAndTrainingEvents)(sortedEventsList, indexOfDayOneInfo);
};
exports.getEventsFromDayOneApiResponse = getEventsFromDayOneApiResponse;
//# sourceMappingURL=getEventsFromDayOneApiResponse.js.map